import { useCallback } from 'react';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import { useDrawerNavigatorOperations } from './useDrawerNavigatorOperations';

type DrawerNavigatorActionPayload = {
  operation: 'show' | 'hide';
};

function useControlDrawerNavigatorActions() {
  const { showDrawerNavigator, hideDrawerNavigator } = useDrawerNavigatorOperations();

  const onControlDrawerNavigator: OnActionType = useCallback(
    ({ action }) => {
      const payload = action.payload as DrawerNavigatorActionPayload;

      switch (payload.operation) {
        case 'show':
          showDrawerNavigator();
          break;
        case 'hide':
          hideDrawerNavigator();
          break;
        default:
          break;
      }
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [showDrawerNavigator, hideDrawerNavigator],
  );

  return { onControlDrawerNavigator };
}

export default useControlDrawerNavigatorActions;
